import { RoleType } from "@explorance/mly-types";

export const isAnyAdmin = (roleType: RoleType) =>
  [RoleType.Admin, RoleType.SuperAdmin].includes(roleType);
